import React from 'react';
import Reflux from 'reflux';
import EventViewStore from 'flux/stores/EventViewStore';

import { Row, Col } from 'bootstrap';
import TimeHelper from 'time';

export default React.createClass({
  displayName: 'GuestCuesheetPageFooter',

  mixins: [Reflux.connect(EventViewStore, 'event')],

  render() {
    const { event } = this.state;

    const current = Date.now();
    const twentyFourHourClock = event.get('twentyFourHourClock');

    return (
      <Row className="printable-cuesheet-footer">
        <Col>
          <div className="printable-cuesheet-footer-quote">
            <a
              href="https://shoflo.tv/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Made at Shoflo.tv
            </a>
          </div>
          <div className="printable-cuesheet-footer-timestamp">
            <p>
              Created {TimeHelper.getFormattedDate(current)} at{' '}
              {TimeHelper.getFormattedTime(current, twentyFourHourClock)}
            </p>
          </div>
        </Col>
      </Row>
    );
  },
});
